import { useQuery } from '@tanstack/react-query'

import { FinanceService } from '@/api/models/finance'

export const INVOICE_BY_ID = 'invoice-by-id'

export const useInvoiceById = (invoiceId: string | null, enabled = true) => {
  return useQuery({
    queryKey: [INVOICE_BY_ID, invoiceId],
    queryFn: () => {
      if (!invoiceId) {
        return
      }
      return FinanceService.getInvoiceById(invoiceId)
    },
    enabled: enabled && !!invoiceId
  })
}
